<template>
  <div>
    <CustomerFeedbackForm v-show="showCfeForm" @close-dialog="$emit('close-dialog', true)" />
    <CustomerFeedbackHideTrainer v-show="showCfeHideTrainerModal" @close-dialog="$emit('close-dialog', true)" />
    <CustomerFeedbackConfirmation v-show="showCfeConfirmation" @close-dialog="$emit('close-dialog', true)" />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import CustomerFeedbackConfirmation from '@/components/Modal/CustomerFeedback/Confirmation';
import CustomerFeedbackForm from '@/components/Modal/CustomerFeedback/Form';
import CustomerFeedbackHideTrainer from '@/components/Modal/CustomerFeedback/HideTrainer';

export default {
  components: {
    CustomerFeedbackConfirmation,
    CustomerFeedbackForm,
    CustomerFeedbackHideTrainer
  },
  created() {
    this.setShowCfeForm(true);
  },
  computed: {
    ...mapState('modal', ['showCfeForm', 'showCfeConfirmation', 'showCfeHideTrainerModal'])
  },
  methods: {
    ...mapMutations('modal', ['setShowCfeConfirmation', 'setShowCfeForm'])
  }
};
</script>
